import React from 'react';
import styled from 'styled-components';
import GitHub from '@material-ui/icons/GitHub';
import Pinterest from '@material-ui/icons/Pinterest';
import PublicIcon from '@material-ui/icons/Public';
import Particle from './Particle';

function Menu({ menuItem }) {
  return (
    <MenuItemStyled>
      {menuItem.map((item) => {
        const { id, categories, image, image_link, link1, link2, title, text } = item;
        return (
          <div className="grid-item" key={id}>
            <Particle />
            <div className="portfolio-content">
              <div className="portfolio-image">
                <ul>
                  {link1 === '' ? (
                    ''
                  ) : (
                    <li>
                      <a href={link1} target="_blank" rel="noreferrer">
                        <PublicIcon />
                        <p>Website</p>
                      </a>
                    </li>
                  )}

                  {link2 === '' ? (
                    ''
                  ) : (
                    <li>
                      <a href={link2} target="_blank" rel="noreferrer">
                        <GitHub />
                        <p>Github</p>
                      </a>
                    </li>
                  )}

                  {image_link === '' ? (
                    ''
                  ) : (
                    <li>
                      <a href={image_link} target="_blank" rel="noreferrer">
                        <Pinterest />
                        <p>Pinterest</p>
                      </a>
                    </li>
                  )}
                </ul>

                <img src={image} alt={title} />
              </div>

              <h6>
                {title}
                <div className="badge">
                  {categories.map((item, id) => {
                    return (
                      <span key={id} className="badge-item">
                        {item}
                      </span>
                    );
                  })}
                </div>
              </h6>
              <p>{text}</p>
            </div>
          </div>
        );
      })}
    </MenuItemStyled>
  );
}

const MenuItemStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2rem;

  @media screen and (max-width: 920px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 670px) {
    grid-template-columns: repeat(1, 1fr);
  }
  .grid-item {
    .portfolio-content {
      display: block;
      position: relative;
      overflow: hidden;

      .badge {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-column-gap: 0.5rem;

        width: 100%;
        padding: 0;
      }
      .badge-item {
        display: inline-block;
        border: 2px solid #ddd;
        border-radius: 50px;
        margin: 4px;
        font-size: 0.6rem;
        text-align: center;
        color: var(--white-color);
        padding: 0 0.3rem;
      }

      h6 {
        font-size: 1.5rem;
      }
      img {
        width: 100%;
        height: 30vh;
        object-fit: cover;
        border-radius: 10px;
      }
      ul {
        transition: all 0.4s ease-in-out;
        position: absolute;

        opacity: 0;
        li {
          background-color: var(--border-color);
          display: flex;
          align-items: center;
          border-radius: 50px;
          width: 2rem;
          height: 2rem;
          margin: 0.5rem;
          transition: all 0.4s ease-in-out;
          &:hover {
            background-color: var(--primary-color);
          }
          a {
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.4s ease-in-out;
            p {
              width: 0;
              padding-left: 0.2rem;
              color: transparent;
            }
            p:hover {
            }
          }
        }
      }

      .portfolio-image {
        &::before {
          content: '';
          position: absolute;
          left: 2%;
          top: 4%;
          height: 0;
          width: 0;
          transition: all 0.4s ease-in-out;
        }
      }
      .portfolio-image {
        ul {
          transition: all 0.4s ease-in-out;
          opacity: 1;
          padding-bottom: 1rem;
          li {
            transition: all 0.4s ease-in-out;
            &:hover {
              background-color: var(--primary-color);
            }
          }

          li:hover {
            width: 110px;
            transition: all 0.4s ease-in-out;
            svg {
              color: var(--white-color);
              text-align: right;
              justify-content: center;
            }
            p {
              color: var(--white-color);
              transition: all 0.4s ease-in-out;
            }
          }
          svg {
            font-size: 2rem;
          }
        }
      }
    }
  }
`;

export default Menu;
